// ============================================================================
// SPANISH TRANSLATIONS - CHAPTER 8: EL SOCORRO DEL ALTÍSIMO (BONUS)
// ============================================================================
// Nivel 92 (1 nivel bonus, 3 preguntas)

export const chapter8Translations = {
  name: "El Socorro del Altísimo",
  description: "El que habita al abrigo del Altísimo morará bajo la sombra del Omnipotente",
  
  spiritualWisdom: {
    principle: "Has llegado a la cima de la montaña, y el conocimiento ha sido adquirido",
    scripture: "El que habita al abrigo del Altísimo morará bajo la sombra del Omnipotente (Salmo 91:1)",
    application: "La fe inquebrantable requiere experiencia de vida, misericordia y el verdadero amor de Jesús. Las pruebas pondrán a prueba tu corazón, el verdadero camino elegido."
  },
  
  levels: {
    92: {
      name: "El Abrigo del Altísimo",
      challenge: "Estás en la cima de la montaña... Pero la fe inquebrantable comienza ahora...",
      easy: {
        question: "¿Quién es Jesús para ti personalmente?",
        options: [
          "Un simple profeta",
          "Mi Señor y Salvador personal",
          "Una leyenda",
          "Un filósofo"
        ],
        hint: "Él es quien da su vida para salvarnos",
        funFact: "✝️ ¡Jesús es Dios! No es solo un personaje histórico - ¡Está vivo y desea una relación personal con cada uno de nosotros!"
      },
      medium: {
        question: "¿Por qué ayunar como Daniel nos permite escuchar mejor a Dios?",
        options: [
          "Para perder peso",
          "Para privarnos de lo que amamos y tener un corazón transformado",
          "Para impresionar a los demás",
          "Para ser más fuerte"
        ],
        hint: "Prívate de lo que más amas, en la calma y la sabiduría",
        funFact: "🙏 ¡El ayuno espiritual prepara nuestro corazón para transformaciones profundas - a menudo dolorosas - que nos acercan a Dios!"
      },
      hard: {
        question: "¿Cuál es la verdadera respuesta del corazón ante todo este conocimiento adquirido?",
        options: [
          "Ahora soy perfecto",
          "Te entrego mi corazón Jesús y deseo ser bautizado",
          "Sé mejor que los demás",
          "Ya no necesito ayuda"
        ],
        hint: "La verdadera fe lleva a la entrega total y al compromiso con Jesús",
        funFact: "🌟✨ Has llegado a la cima de la montaña, y el conocimiento ha sido adquirido ✨\n\n💖 La fe inquebrantable requiere experiencia de vida, misericordia y el verdadero amor de Jesús 💖\n\n🔥 Las diversas pruebas de la vida pondrán a prueba tu camino, el verdadero sendero que elegimos, nuestro corazón 🔥\n\n😔 Permanecemos imperfectos, nuestros deseos son numerosos, y el amor al dinero o a nuestra comodidad personal se convierte demasiado a menudo en nuestra prioridad egoísta 😔\n\n🙏 Pide a Dios sabiduría, su amor, su fuerza, y reconoce tus debilidades humildemente, porque no podemos ocultarle nada... Nada 🙏\n\n🥖 Ayuna como Daniel: prívate por un momento de lo que más amas, en la calma y la sabiduría 🥖\n\n💫 Esto te permitirá escuchar mejor a Dios, tener una disposición del corazón lista para transformaciones profundas 💫\n\n🌙 Entonces, los sueños y las visiones se volverán más claros, como para José 🌙\n\n⚠️ Guárdate del orgullo: no cedas al 'siempre tengo razón' o al 'sé mejor' ⚠️\n\n🎁 Porque la revelación de Dios es una gracia extraordinaria 🎁\n\n💝 Tener fe es entrar en una relación y un camino libre del corazón 💝\n\n🦸‍♂️ Te convertirá en héroes poderosos, capaces de lo imposible 🦸‍♂️\n\n✝️ En la cima del conocimiento, el corazón sincero dice: 'Te entrego mi corazón Jesús y deseo ser bautizado' ✝️\n\n🏔️ Has llegado a la cima de la montaña, ¡agárrate fuerte, persevera! 🏔️\n\n⬇️ Hay que descender y llevar este precioso tesoro: la esperanza de la vida eterna ⬇️\n\n🏆✨ ¡BRAVO! ESTAMOS ORGULLOSOS DE TI ✨🏆\n🌟 VALOR VALIENTE PORTADOR DE PAZ 🌟\n🕊️✨ QUE DIOS TE BENDIGA ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
